import {useMemo} from 'react'

export const useImagePadding = (imageProps, options) => {
    const {padding = 4, enable = true} = options || {}

    return useMemo(() => {
        if (!enable || !imageProps) return imageProps

        const pad = typeof padding === 'number' ? padding : Number(padding) || 0
        if (pad === 0) return imageProps

        const {x = 0, y = 0, width = 0, height = 0} = imageProps
        const totalPad = pad * 2

        return {
            ...imageProps,
            x: x - pad,
            y: y - pad,
            width: width + totalPad,
            height: height + totalPad,
        }
    }, [options, imageProps])
}

export default useImagePadding
